import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { Product, ProductService } from 'src/app/shared-lib/domains/product';
import { environment } from 'src/environments/environment';

@Component({
  templateUrl: './promotion-dialog.component.html',
  styleUrls: ['./promotion-dialog.component.scss'],
  standalone: false
})
export class PromotionDialogComponent implements OnInit {
  slug = environment.options.promotionProductSlug;
  product$: Observable<Product>;
  constructor(
    private productService: ProductService,
    private modalController: ModalController,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.product$ = this.productService.getProductBySlug$(this.slug);
  }

  onView() {
    this.closeDialog(true);
    this.router.navigate(['/papeleria/catalogo', this.slug]);
  }

  closeDialog(view = false) {
    this.modalController.dismiss({
      'view': view
    });
  }

}

